// The consumers table keeps its search, filters, page and sort in the URL. A meter opened from the
// table carries that location in router state so the meter page's back arrow can return to it.
export type ConsumersReturnState = { consumersReturn: string }

export const consumersReturnState = (location: {
  pathname: string
  search: string
}): ConsumersReturnState => ({
  consumersReturn: location.pathname + location.search,
})

// Only a location of the site's consumers table is accepted; anything else falls back to the bare path.
export const consumersReturnTarget = (
  state: unknown,
  siteId: string | undefined
): string => {
  const base = `/${siteId}/consumers`
  const stored = (state as Partial<ConsumersReturnState> | null)
    ?.consumersReturn
  return typeof stored === 'string' &&
    (stored === base || stored.startsWith(`${base}?`))
    ? stored
    : base
}
